export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const uploadImageIcon = require('../assets/upload.svg');
export const closeIcon = require('../assets/close.png');